import { SupportProvider } from "../provider/SupportProvider";

export default class SupportServices {
  static async allChatbotTemplate() {
    const res = await SupportProvider.getChatbotTemplate();
    return res;
  }
  static async childChatbotTemplate(id: number) {
    const res = await SupportProvider.getChildChatbotTemplate(id);
    return res;
  }
  static async registerUserForChat(payload?: any) {
    const res = await SupportProvider.postUserChatData(payload);
    return res;
  }
  static async sendMessage(id: number, payload: { is_file: number; content: string }) {
    const res = await SupportProvider.sendMessage(id, payload);
    return res;
  }
}
